import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
const Main = styled.div`
    margin-top: 50px;
    text-align: center;
`;
const Ifr = styled.iframe`
  pointer-events: none;
  width:100%;
  height: 70vh;
  @media ${device.mobile}{
    height: 44vh;
 }
`;


export default function Instgram() {
  return (
    <Main>
      <div className='mt-3 grid grid-12'>
        <div className='col-span-6'><Ifr scrolling="no" src="https://snapwidget.com/embed/894225"></Ifr></div>
        <div className='col-span-6 mb-3 p-5 font-bold'>今の子どもたちが出ていく社会は、大きな変革を迎えた社会です。 そこで生き抜くためには、考え方が柔軟な幼いうちに多くのトライ＆エラーを経験し、 しなやかに成長することが望まれます。「独自プログラム×最先端カリキュラム」を 誇るSTEMONメソッドで、子どもたちの可能性の輪を大きく広げましょう。</div>
      </div>
    </Main>
  );
}